import { z } from 'zod';
import { DecimalLikeSchema, IsoDateTimeSchema, PaginationSchema, UuidSchema } from './common.js';
// Escrita (request): 'tarjeta' deixou de ser método aceito (#159 B2).
export const ReciboMetodoPagoSchema = z.enum(['efectivo', 'transferencia', 'cheque']);
// Leitura (response): recibos históricos migrados (pré-#159) ainda têm metodoPago='tarjeta'.
// O schema de OUTPUT aceita o valor legado read-only — sem isto, o api-sdk (que valida a
// response com .parse) quebraria a listagem/get desses recibos. A escrita segue bloqueada.
export const ReciboMetodoPagoOutputSchema = z.enum(['efectivo', 'transferencia', 'cheque', 'tarjeta']);
export const ReciboEstadoSchema = z.enum(['generado', 'entregado', 'anulado']);
export const ReciboPagoSchema = z.object({
    id: UuidSchema,
    numeroRecibo: z.string().max(20),
    clienteId: UuidSchema.nullable(),
    clienteManualNombre: z.string().max(200).nullable(),
    facturaId: UuidSchema.nullable(),
    montoPagado: DecimalLikeSchema,
    metodoPago: ReciboMetodoPagoOutputSchema.nullable(),
    fechaPago: IsoDateTimeSchema.nullable(),
    referencia: z.string().max(200).nullable(),
    concepto: z.string().max(500).nullable(),
    observaciones: z.string().max(1000).nullable(),
    estado: ReciboEstadoSchema.nullable(),
    createdBy: UuidSchema.nullable(),
    updatedBy: UuidSchema.nullable(),
    createdAt: IsoDateTimeSchema.nullable(),
    // A-7: a lista inclui o cliente registrado resolvido (ausente nos demais endpoints).
    cliente: z.object({ nombre: z.string() }).nullable().optional(),
});
// Verificación pública del recibo por su número (escaneando el QR). Solo expone
// datos del comprobante — sin campos internos (ids de auditoría, observaciones).
export const ReciboVerificacionSchema = z.object({
    numeroRecibo: z.string(),
    montoPagado: DecimalLikeSchema,
    fechaPago: IsoDateTimeSchema.nullable(),
    metodoPago: ReciboMetodoPagoOutputSchema.nullable(),
    referencia: z.string().nullable(),
    concepto: z.string().nullable(),
    estado: ReciboEstadoSchema.nullable(),
    cliente: z
        .object({
        nombre: z.string(),
        ruc: z.string().nullable(),
        telefono: z.string().nullable(),
        direccion: z.string().nullable(),
    })
        .nullable(),
    factura: z
        .object({
        nroFactura: z.string().nullable(),
        total: DecimalLikeSchema.nullable(),
    })
        .nullable(),
});
// numeroRecibo é gerado pelo service (sequencial). Exige cliente registrado OU
// nome manual — um recibo precisa identificar o pagador.
export const CreateReciboPagoRequestSchema = z
    .object({
    clienteId: UuidSchema.nullable().optional(),
    clienteManualNombre: z.string().max(200).nullable().optional(),
    facturaId: UuidSchema.nullable().optional(),
    montoPagado: DecimalLikeSchema,
    metodoPago: ReciboMetodoPagoSchema.optional(),
    fechaPago: IsoDateTimeSchema.nullable().optional(),
    referencia: z.string().max(200).nullable().optional(),
    concepto: z.string().max(500).nullable().optional(),
    observaciones: z.string().max(1000).nullable().optional(),
})
    .refine((v) => Boolean(v.clienteId) || Boolean(v.clienteManualNombre?.trim()), {
    message: 'cliente_id o cliente_manual_nombre es requerido',
    path: ['clienteId'],
});
export const UpdateReciboPagoRequestSchema = z.object({
    estado: ReciboEstadoSchema.optional(),
    observaciones: z.string().max(1000).nullable().optional(),
    referencia: z.string().max(200).nullable().optional(),
    concepto: z.string().max(500).nullable().optional(),
});
export const ReciboPagoListQuerySchema = PaginationSchema.extend({
    estado: ReciboEstadoSchema.optional(),
    clienteId: UuidSchema.optional(),
    from: IsoDateTimeSchema.optional(),
    to: IsoDateTimeSchema.optional(),
});
//# sourceMappingURL=recibos.js.map